export const UNIT_PREFERENCE_KEY = "mag-portal-unit-preference";
export const LENGTH_PREFERENCE_KEY = "mag-portal-length-preference";

export type UnitChoice = "stem" | "bunch" | "box";

export function readUnitPreference(): UnitChoice | null {
  try {
    const raw = window.localStorage.getItem(UNIT_PREFERENCE_KEY);
    if (raw === "stem" || raw === "bunch" || raw === "box") return raw;
    return null;
  } catch {
    return null;
  }
}

export function writeUnitPreference(unit: UnitChoice): void {
  try {
    window.localStorage.setItem(UNIT_PREFERENCE_KEY, unit);
  } catch {
    // ignore
  }
}

export function readLengthPreference(allowed: number[]): number | null {
  try {
    const raw = window.localStorage.getItem(LENGTH_PREFERENCE_KEY);
    if (raw === null) return null;
    const parsed = parseInt(raw, 10);
    if (!Number.isNaN(parsed) && allowed.includes(parsed)) return parsed;
    return null;
  } catch {
    return null;
  }
}

export function writeLengthPreference(length: number): void {
  try {
    window.localStorage.setItem(LENGTH_PREFERENCE_KEY, String(length));
  } catch {
    // ignore
  }
}

export function clearAllPortalPreferences(): void {
  try {
    window.localStorage.removeItem(UNIT_PREFERENCE_KEY);
    window.localStorage.removeItem(LENGTH_PREFERENCE_KEY);
    window.localStorage.removeItem("mag-portal-catalog-view");
    // Step 6.7: per-variety memory cleared on sign-out (AC125).
    window.localStorage.removeItem("mag-portal-prefs");
    // Step 6.7.2: persisted Zustand unit-preference store.
    window.localStorage.removeItem("mag-portal-unit-pref");
  } catch {
    // ignore
  }
}
